import React from 'react';
export default (function (_ref) {
  var _vm$type;
  var vm = _ref.vm;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: '#ffd3a7',
      padding: 10,
      color: '#9c5309',
      fontSize: 12,
      border: '1px solid #f1b375',
      borderRadius: 4
    }
  }, "Unknown question type \"", vm === null || vm === void 0 ? void 0 : (_vm$type = vm.type) === null || _vm$type === void 0 ? void 0 : _vm$type.replace('_', ' ').toLowerCase(), "\" \u2014 hey, can't win them all \xAF\\_(\u30C4)_/\xAF");
});
//# sourceMappingURL=index.js.map
